import { useMutation } from "@tanstack/react-query";
import { API_URL } from "src/Utils/API";
import { FeatureSwitch } from "src/business/configuration/featureSwitch";
import {
  CreateFeatureSwitchRequest,
  UpdateFeatureSwitchRequest,
} from "../types/featureSwitch";

// POST /web/admin/feature-switches — Admin only
export const useCreateFeatureSwitch = (
  onSuccess?: (featureSwitch: FeatureSwitch) => void,
) =>
  useMutation({
    mutationFn: async (
      payload: CreateFeatureSwitchRequest,
    ): Promise<FeatureSwitch> => {
      const res = await fetch(`${API_URL}/admin/feature-switches`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (res.status === 409) {
        throw new Error("A feature switch with that name already exists.");
      }
      if (res.status === 400) {
        throw new Error("A feature switch name is required.");
      }
      if (!res.ok) {
        throw new Error("Failed to create feature switch.");
      }

      return res.json();
    },
    onSuccess,
  });

// PATCH /web/admin/feature-switches/{id} — Admin only
export const useUpdateFeatureSwitch = (
  onSuccess?: (featureSwitch: FeatureSwitch) => void,
) =>
  useMutation({
    mutationFn: async ({
      id,
      active,
    }: UpdateFeatureSwitchRequest): Promise<FeatureSwitch> => {
      const res = await fetch(`${API_URL}/admin/feature-switches/${id}`, {
        method: "PATCH",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ active }),
      });

      if (res.status === 404) {
        throw new Error("That feature switch no longer exists.");
      }
      if (!res.ok) {
        throw new Error("Failed to update feature switch.");
      }

      return res.json();
    },
    onSuccess,
  });
